import { Box } from "@mui/material";

import { useBasicData } from "@/hooks";

import { PrimaryNavigationFooter } from "./components/PrimaryNavigationFooter/PrimaryNavigationFooter";
import { PrimaryNavigationHeader } from "./components/PrimaryNavigationHeader/PrimaryNavigationHeader";
import { PrimaryNavigationLinks } from "./components/PrimaryNavigationLinks/PrimaryNavigationLinks";
import { RecentSessions } from "./components/RecentSessions/RecentSessions";
import { PrimaryNavigationContentLoader } from "./PrimaryNavigationContentLoader";

export const PrimaryNavigationContent = () => {
  const { activeWorkspace } = useBasicData();

  return (
    <>
      {activeWorkspace ? (
        <>
          <Box sx={{ mb: 2 }}>
            <PrimaryNavigationHeader />
          </Box>
          <Box sx={{ mb: 3 }}>
            <PrimaryNavigationLinks />
          </Box>
          <Box sx={{ mb: 3 }}>
            <RecentSessions />
          </Box>
        </>
      ) : (
        <PrimaryNavigationContentLoader />
      )}
      <PrimaryNavigationFooter />
    </>
  );
};
